const UA = window.navigator.userAgent
const NOKEY_APP = "Nokey"; // 乘趣APP
const VWA_APP = "VWA "; // 安徽大众APP
const VWA_APP_OLD = "VWA/"; // 安徽大众APP老的标识
const SVW_APP = "SVW "; // 上汽大众app webview
const SVW_SDK = "VWSDK"; // 上汽大众乘趣SDK
const VWA_SDK = "VWASDK"; // 安徽大众乘趣SDK
const CHENG_QU_APP = "ChengQu"; // 乘趣APP
const LEXUS_SDK = "LexusSDK"; // 雷克萨斯app
const TIKA_APP = "Tika"; // TIKA APP
const LX_APP = 'Paton'
const RHINOS_APP = 'Rhinos'
const DPCA_APP = 'Dpca'
const DPCA_APP_OLD = 'Dpca/'


let  appType = 'Nokey'
const appMap = [
  NOKEY_APP,         // LX_APP
  VWA_APP,          // VWA_APP
  SVW_SDK,      // LEXUS_SDK
  SVW_APP,        // VWA_SDK
  VWA_SDK,         // SVW_SDK
  LEXUS_SDK,           // SVW_APP
  TIKA_APP,           // TIKA_APP 
  LX_APP,
  VWA_APP_OLD,
  CHENG_QU_APP,
  RHINOS_APP,
  DPCA_APP,
  DPCA_APP_OLD
];

const matched = appMap.find(key => UA.includes(key));
if (matched) {
  appType = matched;
}
const regex =  new RegExp(`${appType}[/, ]\\d{1}\\.\\d{1,2}\\.\\d{1,2}`, 'ig') 
const matchResult = (UA.match(regex)?.[0] as unknown as string)?.split('/')
const isAndroid = UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1 || UA.indexOf('OpenHarmony') > -1;
const isHarmony = UA.indexOf('OpenHarmony') > -1;
export const appInfo = {
  appName: matchResult?.[0] || 'Nokey',
  version: matchResult?.[1] || '1.0.0',
  system: isAndroid ? 'android' : 'ios',
  isAppWebview: !!matched,
  isAndroid,
  isIOS: !isAndroid,
  isNokey: UA.includes(NOKEY_APP),
  isChengQu: UA.includes(CHENG_QU_APP), 
  isTika: UA.includes(TIKA_APP) && !isHarmony,
  isLX: UA.includes(LX_APP) && !isHarmony,
  isVWA: UA.includes(VWA_APP) && !isHarmony,
  isSVW: UA.includes(SVW_APP) && !isHarmony,
  isLexusSDK: UA.includes(LEXUS_SDK),
  isVWASDK: new RegExp(`${VWA_APP}|${VWA_APP_OLD}`).test(UA),
  isSVWSDK: UA.includes(SVW_SDK) && !isHarmony,
  isRhinos: UA.includes(RHINOS_APP) && !isHarmony,
  isDpca: new RegExp(`${DPCA_APP}|${DPCA_APP_OLD}`).test(UA),
  isDpcaPeugeo: UA.includes("DpcaPeugeo") && !isHarmony,
  isOpenHarmony: /OpenHarmony/i.test(UA),
  isSVWHarmonySDK: /OpenHarmony/i.test(UA) && UA.includes(SVW_SDK),
  isDpcaHarmonySDK: /OpenHarmony/i.test(UA) && UA.includes(DPCA_APP_OLD),
  isDpcaPeugeoHarmonySDK: /OpenHarmony/i.test(UA) && UA.includes("DpcaPeugeo"),
}
